import styled from '@emotion/styled/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ButtonWrapper = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
`

export const AppointmentActivityIcons = styled(FontAwesomeIcon)`
  color: #989898;
  font-size: 1.2rem;
  margin-right: 8px;
`

export const AppointmentActivityTexts = styled.p`
  color: #3c4043;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 20px;
  margin: 0;
  opacity: 1;
  text-transform: none;
`

export const AppointmentMenuButton = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: transparent;
  background-position: center;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  height: 36px;
  margin-right: 8px;
  padding: 8px;
  transition: background 0.8s;

  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const AppointmentActivityButton = styled.button`
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  background-color: transparent;
  background-position: center;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  height: 36px;

  padding: 8px;
  transition: background 0.8s;

  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const AppointmentActivityInnerWrapper = styled.div`
  display: flex;
`
